import { LeaderboardConfig, WorkoutType } from '../../../config';
import { CardioOrResistance } from '../../../entities';
import { HomeGroupClass, IPointInTimeInfo } from '../../../logic/leaderboard/homegroupclass';
import { TemplateLeaderboard } from '../../../logic/leaderboard/leaderboardmanager';
import { IHomeGroupClassRepository } from '../interfaces';

interface IWorkoutLeaderboard {
  [key: string]: HomeGroupClass;
}
export class InMemoryHomeGroupClassRepository implements IHomeGroupClassRepository {
  private templateLeaderboard: TemplateLeaderboard;
  private workoutLeaderboards: IWorkoutLeaderboard = {};

  public addTemplateLeaderboard(templateLeaderboard: TemplateLeaderboard): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.templateLeaderboard = templateLeaderboard;
      resolve();
    });
  }

  public getTemplateLeaderboard(
    workoutType: WorkoutType): Promise<HomeGroupClass> {
    return new Promise<HomeGroupClass>((resolve, reject) => {
      const templateLeaderboardClone = HomeGroupClass.clone(this.templateLeaderboard[workoutType]);
      resolve(templateLeaderboardClone);
    });
  }

  public getWorkoutLeaderboard(
    workoutId: string,
    cardioOrResistance: CardioOrResistance,
    workoutType: WorkoutType,
  ): Promise<HomeGroupClass> {
    return new Promise<HomeGroupClass>((resolve, reject) => {
      const cacheKey = HomeGroupClass.calculateReferenceNumber(workoutId, workoutType);
      resolve(this.workoutLeaderboards[cacheKey]);
    });
  }

  public addWorkoutLeaderboard(
    workoutId: string,
    cardioOrResistance: CardioOrResistance,
    workoutType: WorkoutType,
    templateLeaderboard: HomeGroupClass,
  ): Promise<HomeGroupClass> {
    return new Promise<HomeGroupClass>((resolve, reject) => {
      const cacheKey = HomeGroupClass.calculateReferenceNumber(workoutId, workoutType);
      this.workoutLeaderboards[cacheKey] = templateLeaderboard;
      resolve(this.workoutLeaderboards[cacheKey]);
    });
  }

  public updateWithUserInfoAtTime(
    usersPointInTime: IPointInTimeInfo,
    secondInWorkout: number,
    botWorkoutIdToRemove: string | undefined,
    workoutId: string,
    cardioOrResistance: CardioOrResistance,
    workoutType: WorkoutType,
  ): Promise<HomeGroupClass> {
    return new Promise<HomeGroupClass>((resolve, reject) => {
      const cacheKey = HomeGroupClass.calculateReferenceNumber(workoutId, workoutType);
      const leaderboard = this.workoutLeaderboards[cacheKey];

      const totalSeconds = Object.keys(leaderboard.pointInTimeLeaderboard);
      const lastSecond = parseInt(totalSeconds[totalSeconds.length - 1], 10);
      for (let i = secondInWorkout; i <= lastSecond; i += LeaderboardConfig.secondInterval) {
        leaderboard.addPointInTimeToLeaderboard(i.toString(), usersPointInTime, botWorkoutIdToRemove);
      }

      this.workoutLeaderboards[cacheKey] = leaderboard;
      resolve(this.workoutLeaderboards[cacheKey]);
    });
  }

  public removeOldWorkoutLeaderboards(date: Date): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      Object.keys(this.workoutLeaderboards).forEach((key) => {
        const leaderboard = this.workoutLeaderboards[key];
        const { createdAt } = leaderboard;

        const lifespanMs = LeaderboardConfig.lifespanOfWorkoutLeaderboardHour * 60 * 60 * 1000;
        if ((date.getTime() - new Date(createdAt).getTime()) > lifespanMs) {
          delete this.workoutLeaderboards[key];
        }
      });

      resolve();
    });
  }
}
